export enum JobInvoicePath {
	FULL_SERVICE = "FULL_SERVICE",
	BILL = "BILL",
	FINANCE = "FINANCE",
	PARTS_ONLY = "PARTS_ONLY"
}

export const JobInvoicePathLabelEnum: {[key: string] : string} = {
	[JobInvoicePath.FULL_SERVICE]: "Full Service",
	[JobInvoicePath.BILL]: "Bill Path",
	[JobInvoicePath.FINANCE]: "Finance Path",
	[JobInvoicePath.PARTS_ONLY]: "Parts-only"
}